import SolutionTemplate from '@LandingFunctionalDisplay/SolutionTemplate';
import { facilitiesData } from '@LandingFunctionalDisplay/SolutionTemplate/solutionData';

export default function FacilitiesPage() {
    return <SolutionTemplate {...facilitiesData} />;
}
